/**
 * @file Account level custom print redirect container.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import compose from 'lodash.flowright';
import { graphql } from 'react-apollo';
import get from 'lodash.get';

import Spinner from '../../../../components/global/Spinner';
import ContentWrap from '../../../../components/global/ContentWrap';
import { getAsset } from '../../../../util/assets';
import {
  CUSTOM_PRINT_TYPE,
  ORDER_STATUS,
} from '../../../../constants/pro-custom-prints';
import { AccountPurchasedCustomPrints } from '../../graphql/queries/custom-prints';

class CustomPrintAccountRedirectContainer extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    pendingPurchasedCustomPrints: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
      }),
    ),
  };

  render() {
    const { loading, pendingPurchasedCustomPrints } = this.props;
    const [firstPendingCustomPrint] = pendingPurchasedCustomPrints || [];

    if (loading || !pendingPurchasedCustomPrints) {
      return (
        <div className="text-center py-5">
          <Spinner />
        </div>
      );
    }

    if (firstPendingCustomPrint) {
      return (
        <Redirect
          to={`/consumer/custom-prints/${firstPendingCustomPrint.id}`}
        />
      );
    }

    return (
      <div className="wrapper-main">
        <div className="content-wrap content-wrap-gray">
          <ContentWrap size="sm">
            <div className="text-center">
              <h2 className="mb-3">No prints need your attention yet!</h2>
              <img
                width="100px"
                src={getAsset('/waldo-icon.svg')}
                alt="Confused Waldo Icon"
                className="mb-3"
              />

              <p className="text-muted m-0">
                Either we&rsquo;ve got &rsquo;em all &hellip;configured out or
                you should be expecting some more photos. If so, I&rsquo;ll let
                you know soon!
              </p>
            </div>
          </ContentWrap>
        </div>
      </div>
    );
  }
}

const withCustomerInputPurchasedCustomPrints = graphql(
  AccountPurchasedCustomPrints,
  {
    options: () => ({
      variables: {
        orderStatuses: [ORDER_STATUS.CUSTOMER_INPUT],
        customPrintTypes: [
          CUSTOM_PRINT_TYPE.CUSTOM_PRINT,
          CUSTOM_PRINT_TYPE.COLLAGE,
        ],
      },
      fetchPolicy: 'cache-and-network',
    }),
    props: ({ data: { me, loading } }) => ({
      loading,
      pendingPurchasedCustomPrints: get(
        me,
        'purchased_custom_prints.records',
        [],
      ),
    }),
  },
);

export default compose(withCustomerInputPurchasedCustomPrints)(
  CustomPrintAccountRedirectContainer,
);
